<template>
    <Edit-Common
        v-if="data"
        :data="data"
        :depots="depots"
        :allDepots="allDepotsList"
        :showAddDepot="false"
        :vehicleList="[]"
        :configurations="configurations"
        :isDestinationDepotEnabled="isDestinationDepotEnabled"
        @updateVehicleDetails="updateVehicleDetails" />
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import Edit from '@common/components/mdm-v2/vehicle-detail/edit';

export default {
  components: {
    'Edit-Common': Edit,
  },
  data() {
    return {
      vehicle_number: null,
      detailsTab: 'details',
      data: null,
    };
  },
  created() {
    this.vehicle_number = this.$route.params.id;
    this.loadVehicleDetails();
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      currentClient: 'app/currentClient',
      configurations: 'app/configurations',
    }),
    isDestinationDepotEnabled() {
      return this.$hasFeature('vehicle_destination_depot_mapping');
    },
    allDepotsList() {
      return this.depots && this.depots.map(depot => ({
        name: depot.name,
        id: depot.id,
      }));
    },
  },
  methods: {
    async loadVehicleDetails() {
      const result = await this.$store.dispatch('mdmV2/search',
        { section: this.$router.history.current.meta.sectionName,
          params: { vehicle_number: this.vehicle_number } });
      if (result && result.error) {
        this.$errorMessage({ message: `Vehicle Detail:${result.error}` });
      } else {
        this.data = this.constructLocalData(result);
      }
    },
    constructLocalData(result) {
      let localData = cloneDeep(result);
      localData = localData ? localData.map((value) => {
        const obj = {
          number: value.vehicles && value.vehicles[0].number,
          vehicle_type: (value.vehicles && value.vehicles[0].type && value.vehicles[0].type.short_form) ? value.vehicles[0].type.short_form : '-',
          vehicle_model: (value.vehicles && value.vehicles[0].vehicle_model) || '-',
          transporter: (value.vehicles && value.vehicles[0].transporter_id &&
                value.vehicles[0].transporter_id.vname) ?
            value.vehicles[0].transporter_id.vname : '-',
          chasis_number: (value.vehicles && value.vehicles[0].chasis_number) || '-',
          material_type: (value.vehicles && value.vehicles[0].material_type) || '-',
        };
        return Object.assign(value, obj);
      }) : {};
      return localData;
    },
    constructUploadDataPayload(data) {
      const result = {
        chasis_number: data[0].chasis_number,
        vehicle_model: data[0].vehicle_model,
        // eslint-disable-next-line no-underscore-dangle
        vehicle_type_id: data[0].vehicles[0].type._id,
        depots: [],
      };
      const depotsData = data[0].vehicles.map(vehicle => ({
        depot_id: vehicle.depot.id,
        tare_weight: vehicle.tare_weight,
        vehicle_length: vehicle.vehicle_length,
        vehicle_width: vehicle.vehicle_width,
        vehicle_height: vehicle.vehicle_height,
        vehicle_uom: vehicle.vehicle_uom,
        vehicle_filled_weight: vehicle.vehicle_filled_weight,
        vehicle_gross_weight: vehicle.vehicle_gross_weight,
        vehicle_volume: vehicle.vehicle_volume,
        is_vehicle_available: vehicle.is_vehicle_available,
        fleet_type: vehicle.fleet_type,
        ...(this.isDestinationDepotEnabled && vehicle.destination_depots ? {
          destination_depots: vehicle.destination_depots.map(d => d._id || d.id || d),
        } : {}),
      }));
      result.depots = depotsData;
      return result;
    },
    async updateVehicleDetails(data) {
      const payload = this.constructUploadDataPayload(data);
      const number = this.vehicle_number;
      const result = await this.$store.dispatch('mdmV2/editVehicleDetails', { payload, number });
      if (result && result.error) {
        this.$errorMessage({ message: `Vehicle Details:${result.error}` });
      } else {
        this.$successMessage({ message: this.$t('MDM_VEHICLE_DETAIL_UPDATE_SUCCESS') });
      }
    },
  },
};
</script>
